import * as React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { Unit } from '../../../api/models/TaxonomyElement';
import { QuotedProduct, Delivery, MissingProduct } from '../../../api/models/QuotedData';
import ProductPropertiesList from './ProductPropertiesList';
import { ProductProperty } from '../../../api/models/ProductProperty';

type Props = {
    quotedOrder: Delivery,
    missingProducts: MissingProduct[] | null
}

class ProductsListQuote extends React.Component<Props> {
    renderForQuote(products: QuotedProduct[], missingProducts: MissingProduct[] | null) {
        if (products.length === 0)
            return (<Typography variant="h3">Your order is empty</Typography>)
        else return (
            <div>
                <div>
                    <Grid alignItems="center" alignContent="center" container style={{ paddingBottom: '10px' }}>
                        <Grid item xs={4} sm={4} className="table-item">
                            <Typography variant="subtitle1">PRODUCT</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} className="table-item">
                            <Typography variant="subtitle1">PROPERTIES</Typography>
                        </Grid>
                        <Grid item xs={2} sm={2} className="table-item" style={{ textAlign: "center" }}>
                            <Typography variant="subtitle1">AVAILABLE</Typography>
                        </Grid>
                        <Grid item xs={2} sm={2} className="table-item" style={{ textAlign: "center" }}>
                            <Typography variant="subtitle1">QUANTITY</Typography>
                        </Grid>
                    </Grid>
                </div>

                {(missingProducts && missingProducts.length > 0) &&
                    <span>
                        {missingProducts.map((p, i) => {
                            return this.renderRow(p.name, p.selectedProperties, false, null, null, i)
                        })}
                    </span>
                }

                {products.map((p, i) => {
                    return this.renderRow(p.name, p.selectedProperties, true, p.quantity, p.unit, i)
                })}
            </div>
        )
    }

    renderRow = (name: string, selectedProperties: ProductProperty[], available: boolean, quantity: number | null, unit: Unit | null, i: number) => {
        return (
            <Grid alignItems="center" alignContent="center" container key={i} style={{ paddingBottom: '10px' }}>
                <Grid item xs={4} sm={4} className="table-item">
                    <Typography variant="body2" style={{ color: available ? "inherit" : "red" }}>{name}</Typography>
                </Grid>

                <Grid item xs={4} sm={4} className="table-item">
                    <ProductPropertiesList prodProperties={selectedProperties} />
                </Grid>

                <Grid item xs={2} sm={2} className="table-item" style={{ textAlign: "center" }}>
                    <Typography variant="body2" style={{ color: available ? "green" : "red" }}>
                        {available ?
                            "YES"
                            :
                            "NOT AVAILABLE"
                        }
                    </Typography>
                </Grid>

                <Grid item xs={3} sm={2} className="table-item" style={{ textAlign: "center" }}>
                    {(quantity === null || unit === null) ?
                        <Typography variant="body2">-</Typography>
                        :
                        <Typography variant="body2">{quantity}&nbsp;{unit ? (unit as Unit).name.toUpperCase() : ''}</Typography>
                    }
                </Grid>
            </Grid >
        )
    }

    render() {
        return (
            <div>
                {this.renderForQuote(this.props.quotedOrder.items, this.props.missingProducts )}
            </div>
        );
    }
}

export default ProductsListQuote;